import locales from "../locales";
import {ColumnFilterItem} from "antd/lib/table";
import {EventType} from "../api/dtos/dtos";
import {OptionProps} from "antd/lib/select";

const eventTypeLabels = {
  [EventType.PERSONAL_MEETING]: locales.event_type_personal,
  [EventType.ONLINE_MEETING]: locales.event_type_online,
  [EventType.TODO]: locales.event_type_todo
};

export function renderEventTypeElement(type: EventType) {
  return eventTypeLabels[type];
}

export function getEventTypeFilters(): ColumnFilterItem[] {
  return [EventType.PERSONAL_MEETING, EventType.ONLINE_MEETING, EventType.TODO]
    .map(state => ({text: eventTypeLabels[state], value: state}));
}

export function getEventTypeOptions(): OptionProps[] {
  return [EventType.PERSONAL_MEETING, EventType.ONLINE_MEETING, EventType.TODO]
    .map(type => ({value: type, key: type, title: eventTypeLabels[type]}));
}


// WEBPACK FOOTER //
// ./src/client-calendar/EventType.tsx